export const index = {
  registerButton: 'Jetzt kostenlos registrieren',
  bannerTitle: 'IMMOBILIE EINFACH ONLINE VERWALTEN',
  belowButtonText: 'völlig unverbindlich und ohne versteckte Kosten!',
  bannerText:
    'Hausverwaltung sollte einfacher sein, deshalb haben wir für Sie myHausHeld entwickelt. Probieren Sie es jetzt aus!',
  advantagesTitle: 'myHausHeld-Vorteile',
  advantagesTitle1: 'Digitale Renovationsverwaltung',
  advantagesText1:
    'Mit myHausHeld behalten Sie den Überblick über den Projektfortschritt und verwalten ihre Offerten, Aufgaben und Termine zentral an einem Ort.',
  advantagesTitle2: 'Ihre Individuelle Gebäudeanalyse',
  advantagesText2:
    'Mit unserem Sanierungsrechner können Sie den optimalen Sanierungszeitpunkt und die anfallenden Sanierungskosten für Ihre Liegenschaft berechnen. Somit sparen Sie Zeit, Geld und Nerven.',
  advantagesTitle3: 'Alle Handwerker unter einem Dach',
  advantagesText3:
    'Auf der myHausHeld-Seite können Sie alle Ihre Handwerker verwalten. Sie können eigene Handwerker zu Ihrer Liste hinzufügen oder die von HausHeld zur Verfügung gestellten Handwerker anschauen.',
  personalAccessTitle: 'Ihr ganz persönlicher myHausHeld-Zugang - Einfach Überall',
  personalAccessText:
    'Mit ihrem kostenlosen Konto können Sie jederzeit auf alle Funktionen von myHausHeld zugreifen. Planen Sie ihre Sanierungen, betrachten Sie Ihre Offerten, analysieren Sie den Zustand Ihres Gebäudes und vieles mehr.',
  tryItOut: 'JETZT KOSTENLOS TESTEN',
  tryItOutText: 'Mit myHausHeld Zeit, Geld und Nerven sparen.',
  text2:
    'Wir sind der Meinung, Hausverwaltung sollte einfacher sein. Deshalb haben wir für Sie den myHausHeld entwickelt. Nützliche Anwendungen nehmen Ihnen Arbeit ab und erleichtern Ihnen die Hausverwaltung. Doch Sie sparen nicht nur Zeit, sondern möglicherweise auch Geld. Beispielsweise mit dem Energierechner oder dem Steuerkalkulator. Finden Sie es jetzt heraus.',
  text3: 'Alle Renovationen im Überblick',
  text4:
    'Mit unserem Sanierungsrechner können Sie den optimalen Sanierungszeitpunkt und die anfallenden Sanierungskosten für Ihre Liegenschaft berechnen. Zudem vermeiden Sie damit den Fehler, die Gebäudekomponenten in der falschen Reihenfolge zu ersetzen. Somit sparen Sie Zeit, Geld und Nerven.',
  text5: 'Jetzt Immobilien erfassen',
  text6: 'Ihre Individuelle Gebäudeanalyse',
  text7:
    'Mit unserem Sanierungsrechner können Sie den optimalen Sanierungszeitpunkt und die anfallenden Sanierungskosten für Ihre Liegenschaft berechnen. Zudem vermeiden Sie damit den Fehler, die Gebäudekomponenten in der falschen Reihenfolge zu ersetzen. Somit sparen Sie Zeit, Geld und Nerven.',
  text8: 'Einfach mehr Energie sparen',
  text9:
    'Lohnt sich eine Sanierung der Fenster für mich? Solche und ähnliche Fragen beantwortet Ihnen unser Energierechner. Er zeigt Ihnen auf, bei welchen Gewerken das grösste Einsparpotenzial besteht. Durch eine energetische Sanierung reduzieren Sie nicht nur Ihren CO-2 Ausstoss, sondern Sie sparen wertvolle Energie und somit auch Kosten.',
  text10: 'Jetzt Energiesparpotenzial ermitteln',
  text11: 'Ihre Finanzen auf einen Blick',
  text12:
    'Vergleichen Sie verschiedene Hypotheken und finden Sie das passende Angebot. Unsere Partner bieten Ihnen eine transparente, ehrliche und persönliche Beratung. Wählen Sie zwischen einer grossen Auswahl an Anbietern aus der ganzen Schweiz und profitieren Sie von niedrigen Zinsen.',
  text13: 'Jetzt Finanzen optimieren',
  text14: 'Steuerbelastung optimieren',
  text15:
    'Berechnen Sie jetzt in unserem Steuerkalkulator, wie sich die Unterhaltskosten auf die Steuerlast auswirkt. Basierend auf Ihren Daten berechnen wir für Sie die individuelle Steuerersparnis.',
  text16: 'Jetzt Steuersparnis berechnen',
  howItWorksTitle: 'So funktioniert myHausHeld',
  howItWorksTitle1: 'Registrieren',
  howItWorksText1: 'Registrieren Sie sich einfach und unkompliziert bei myHausHeld.',
  howItWorksTitle2: 'Immobilie erfassen',
  howItWorksText2:
    'Erfassen Sie mit nur wenigen Informationen Ihre erste Immobilie und erhalten Sie umgehend kostenlos Ihre erste Gebäudeanalyse.',
  howItWorksTitle3: 'Fertig!',
  howItWorksText3:
    'Verwalten Sie all Ihre Immobilien und Renovationen und profitieren Sie von weiteren Funktionen.',
  text24: 'Kostenlos Gebäudeanalyse erhalten',
  text25: 'Bitte geben Sie Ihre Adresse ein',
  text26: '071 - 508 72 15',
  text27: 'Erreichbarkeit: Mo-Fr 9-17 Uhr',
  text28: 'kontakt@hausheld.ch',
  text29: 'Wir melden uns in 48 Stunden',
  text30: 'Oder benutzen Sie unser Kontaktformular',
  text31: 'Copyright © 2021 myHausHeld',
  text32: 'Bitte geben Sie Ihre Adresse ein',
  text33: 'Anmelden',
  text34: 'AGB',
  text35: 'Impressum',
  text36:
    'Um unsere Webseite für Sie zu optimieren, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.',
  text37: 'Verstanden',
  text38: 'Mehr erfahren',
  text39: 'ok',
  bannerBeforeCraft: 'VERWALTEN SIE IHR ',
  bannerAfterCraft: '-PROJEKT DIGITAL AUF MYHAUSHELD',
  bannerTextCraft: 'Jetzt auf myHausHeld anmelden und Ihre gewünschte Renovation verwalten!',
  buttonTextCraft: 'Jetzt loslegen!',
  password: 'Gewünschtes Passwort eingeben',
  repeatPassword: 'Passwort wiederholen',
  createPasswordError: 'Passwort konnte nicht gesetzt werden.',
  airconditioning: 'Klimaanlage',
  alarmsystem: 'Alarmanlage',
  architect: 'Architekt',
  assembling: 'Montage',
  awnings: 'Markisen',
  balcony: 'Balkon',
  bath: 'Bad',
  broker: 'Makler',
  carport: 'Carport',
  carpenter: 'Schreiner',
  chargingcolumn: 'Ladestation',
  chippie: 'Zimmermann',
  electrician: 'Elektriker',
  fence: 'Zaun',
  floorer: 'Bodenleger',
  gardener: 'Gärtner',
  garage: 'Garage',
  heating: 'Heizung',
  isolation: 'Isolation/Fassaden',
  kitchen: 'Küchen',
  metalconstruction: 'Metallbau',
  painter: 'Maler',
  paver: 'Plattenleger',
  pergola: 'Pergola',
  railing: 'Geländer',
  rollerblinds: 'Storen',
  roofer: 'Dachdecker',
  solarplants: 'Solaranlagen',
  stair: 'Treppen',
  waterconditioning: 'Wasseraufbereitung',
  whirlpool: 'Whirlpool',
  window: 'Fenster',
  wintergarden: 'Wintergarten',
  creationDate: 'Erstellungsdatum',
  ourPartners: 'Unsere Partner',
  myHHTryItOutTitle: 'EINFACH AUSPROBIEREN!',
  myHHTryItOutText: 'myHausHeld ist vollkommen kostenlos und jederzeit problemlos kündbar.',
}
